import stylesheet from './TileGroup.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTileGroup extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const scrollContainer = document.createElement('div');
        scrollContainer.classList.add('scroll-container')
        const tileContainer = document.createElement('div');
        tileContainer.classList.add('tiles')
        scrollContainer.appendChild(tileContainer);
        this.cloneDefaultSlotContentIntoContainer(tileContainer)
        return scrollContainer;
    }

}

customElements.define('nxt-tile-group', NXTTileGroup);
